"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
* End user part entry point.
* Do all routing work in application, nodejs backend only routes to root.
*/
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var common_1 = require('@angular/common');
var http_1 = require('@angular/http');
var welcome_component_1 = require('./steps/welcome/welcome.component');
var phone_component_1 = require('./steps/phone/phone.component');
var phonecall_component_1 = require('./steps/phonecall/phonecall.component');
var error_component_1 = require('./steps/error/error.component');
var code_error_component_1 = require('./steps/code-error/code-error.component');
var success_component_1 = require('./steps/success/success.component');
var code_success_component_1 = require('./steps/code-success/code-success.component');
var license_component_1 = require('./steps/license/license.component');
var about_component_1 = require('./steps/about/about.component');
var service_modules_component_1 = require('./service-modules/service-modules.component');
var noservice_component_1 = require('./noservice/noservice.component');
var core_2 = require('angular2-cookie/core');
var clientinfo_service_1 = require('./clientinfo.service');
var io = require('socket.io-client/lib');
var _isEmpty = require('lodash/isEmpty');
var _result = require('lodash/result');
var AppComponent = (function () {
    function AppComponent(router, http, location, cookieService, clientInfo) {
        this.router = router;
        this.http = http;
        this.location = location;
        this.cookieService = cookieService;
        this.clientInfo = clientInfo;
        //Service model instance
        this.service = {};
    }
    // Determines which text show in header
    AppComponent.prototype.getHeaderTitle = function () {
        var text = '';
        switch (this.location.path()) {
            case '/welcome':
                text = 'Бесплатный';
                break;
            case '/phone':
                text = 'Ваш номер телефона';
                break;
            case '/phonecall':
                text = 'Подтверждение';
                break;
            case '/error':
                text = 'Ошибка';
                break;
            case '/codeerror':
                text = 'Error';
                break;
            case '/success':
                text = 'Готово';
                break;
            case '/codesuccess':
                text = 'Ready';
                break;
            case '/license':
                text = 'Пользовательское соглашение';
                break;
            case '/about':
                text = 'Иформация';
                break;
            case '/advert':
                text = '';
                break;
        }
        return text;
    };
    AppComponent.prototype.ngOnInit = function () {
        //Open websocket
        this.clientInfo.socket = io('http://wifi42.ru');
        this.getUserIP();
    };
    // Gets user IP and check in Oracle if service exist on this IP
    AppComponent.prototype.getServiceByIP = function () {
        var _this = this;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post('/api/client/byip', JSON.stringify(this.clientInfo.userOrder), { headers: headers })
            .map(function (response) { return response.json(); })
            .subscribe(function (response) {
            // If auth by code exist added this info to client service
            if (response.code_access === 1) {
                _this.clientInfo.code_access = response.code_access;
            }
            // Codes: 0, 1, 2 common for phone and code auth
            // Codes: 3, 4, 5 used only for code auth
            // User scenarios for code 3 and 4 similar to code 1
            // but code 3 will be like default auth by phone because code auth was disabled
            // in oracle. Code 4 - user need try to authenticate with code again
            // Service with specified IP not found
            if (response.code == 0) {
                _this.router.navigate(['NoService']);
            }
            else if (response.code == 1 || response.code == 3 || response.code == 4) {
                _this.clientInfo.service = response.data;
                _this.clientInfo.userOrder.service_id = response.data.service_id;
                //Protection if browser was closed. We should check if user was already authentificated
                //Browser can sleep or be closed when user make call to authorization number
                _this.checkToken();
            }
            else if (response.code == 2) {
                _this.clientInfo.service = response.data;
                _this.clientInfo.userOrder.service_id = response.data.service_id;
                if (response.code_access === 1) {
                    _this.router.navigate(['CodeSuccess']);
                }
                else {
                    _this.router.navigate(['Success']);
                }
            }
            // This code will be returned if we sen existing in cookies auth code, but was some error
            if (response.code == 5) {
                _this.router.navigate(['CodeError']);
            }
        });
    };
    AppComponent.prototype.getUserIP = function () {
        var _this = this;
        this.http.get('/api/user/ip')
            .map(function (response) { return response.json(); })
            .subscribe(function (data) { _this.clientInfo.userOrder.ip = data.clientIp; }, function (err) { return console.error(err); }, function () { _this.getServiceByIP(); });
    };
    //Check if user has token from previous authorizations
    AppComponent.prototype.checkToken = function () {
        var _this = this;
        // When brwser closed on phone call. Service wiil be loaded from begin. We check token and if it exist
        // make call to check if user's authentification was success
        var name = 'token' + this.clientInfo.userOrder.service_id;
        var token = this.cookieService.get('token' + this.clientInfo.userOrder.service_id);
        if (token) {
            this.clientInfo.socket.emit('amiAuthentificated', token);
            this.clientInfo.socket.on('haveSession', function (data) {
                console.log('haveSession emited');
                if (data.auth) {
                    _this.router.navigate(['Success']);
                }
            });
        }
    };
    //Checks if route '/advert'
    AppComponent.prototype.isAdvertPage = function () {
        if (this.router.isRouteActive(this.router.generate(['Advert'])))
            return true;
        else
            return false;
    };
    //Checks if route '/noservice'
    AppComponent.prototype.isNoServicePage = function () {
        if (this.router.isRouteActive(this.router.generate(['NoService'])))
            return true;
        else
            return false;
    };
    AppComponent.prototype.hasLogo = function () {
        return !_isEmpty(_result(this.clientInfo, 'service.logoURL'));
    };
    AppComponent.prototype.getBgColor = function () {
        if (this.hasLogo()) {
            return '#' + this.clientInfo.service['color.rgb'];
        }
        return '#FF6400';
    };
    AppComponent = __decorate([
        router_deprecated_1.RouteConfig([
            { path: '/', component: welcome_component_1.WelcomeComponent, as: 'Welcome', useAsDefault: true },
            { path: '/phone', component: phone_component_1.PhoneComponent, as: 'Phone' },
            { path: '/phonecall', component: phonecall_component_1.PhoneCallComponent, as: 'PhoneCall' },
            { path: '/error', component: error_component_1.ErrorComponent, as: 'Error' },
            { path: '/codeerror', component: code_error_component_1.CodeErrorComponent, as: 'CodeError' },
            { path: '/success', component: success_component_1.SuccessComponent, as: 'Success' },
            { path: '/codesuccess', component: code_success_component_1.CodeSuccessComponent, as: 'CodeSuccess' },
            { path: '/license', component: license_component_1.LicenseComponent, as: 'License' },
            { path: '/about', component: about_component_1.AboutComponent, as: 'About' },
            { path: '/advert', component: service_modules_component_1.ServiceModulesComponent, as: 'Advert' },
            { path: '/noservice', component: noservice_component_1.NoServiceComponent, as: 'NoService' },
        ]),
        core_1.Component({
            selector: 'smartwifi-app',
            template: require('./app.template.html'),
            directives: [router_deprecated_1.ROUTER_DIRECTIVES],
            providers: [core_2.CookieService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object, (typeof (_c = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _c) || Object, (typeof (_d = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _d) || Object, (typeof (_e = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _e) || Object])
    ], AppComponent);
    return AppComponent;
    var _a, _b, _c, _d, _e;
}());
exports.AppComponent = AppComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.component.ts
 ** module id = 934
 ** module chunks = 1
 **/